module.exports = __webpack_public_path__ + "static/media/LibertyMile_Blog_default.608c1260.svg";